export const lpMainSearchFormStyles = {
  SearchFormNavBar: {},
  mainSearchForm: {
    borderRadius: "1.0625rem",
    background:
      "linear-gradient(92deg, rgba(255, 169, 0, 0.60) 17.31%, rgba(255, 236, 200, 0.60) 58.64%, rgba(255, 169, 1, 0.60) 106.46%)",
    backdropFilter: "blur(15.5px)",
  },
};
